<script>
import logoSrc from '@assets/images/logo3.png'

export default {
  name: 'AnonymousNavBar',
  data() {
    return {
      logoSrc,
    }
  },
  methods: {
    switchLocale(lang) {
      localStorage.setItem('lang', lang)
      this.$i18n.locale = lang
    },
  },
}
</script>

<template>
  <nav class="navbar fixed-top navbar-expand-lg navbar-dark anonymousNavbar">
    <a class="navbar-brand" style="margin-left: 64px">
      <img :src="logoSrc" width="25" height="25" class="d-inline-block align-bottom" alt="" />
    </a>
    <div id="translate" class="nav-item dropdown">
      <a
        id="navbarDropdown"
        style="color: white; margin-right: 64px"
        class="nav-link dropdown-toggle"
        href="#"
        role="button"
        data-bs-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <span class="translateIcon" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="18" height="18" focusable="false">
            <path
              fill="currentColor"
              d="M12.87 15.07 11 13.2l.97-.97c1.3-1.45 2.31-3.15 3.03-5.03h2V5h-7V3H8v2H1v2h11.17c-.58 1.64-1.48 3.2-2.67 4.54-.78-.87-1.43-1.84-1.94-2.87H5.62c.62 1.47 1.48 2.83 2.56 4.01L4.44 16.4 5.85 17.8 9.6 14c.93.8 1.98 1.49 3.12 2.04l.15-.97Zm5.63-3.07h-2l-4.5 12h2l1.12-3h4.75l1.13 3h2l-4.5-12Zm-2.5 7 1.62-4.33L19.25 19H16Z"
            />
          </svg>
        </span>
        <strong class="translate">{{ $i18n.locale }}</strong>
      </a>
      <div class="dropdown-menu" aria-labelledby="navbarDropdown" style="cursor: pointer; min-width: 32px">
        <a class="dropdown-item" @click="switchLocale('es')">Español</a>
        <a class="dropdown-item" @click="switchLocale('en')">English</a>
      </div>
    </div>
  </nav>
</template>

<style lang="scss" scoped>
@use '@design' as *;

.translate {
  margin: 2px;
  text-transform: capitalize;
}

.translateIcon {
  display: inline-flex;
  vertical-align: text-bottom;
}

.anonymousNavbar {
  display: flex;
  justify-content: space-between;
}

@media (max-width: 992px) {
  #translate > a {
    padding-left: 0;
  }
}

.navbar-brand {
  margin-left: 1rem;
}
</style>
